import { createContext, useReducer, useEffect } from "react";

const AuthenticationContext = createContext();

export const AuthenticationConsumer = AuthenticationContext.Consumer;
export default AuthenticationContext;
